// extracted by mini-css-extract-plugin
export var activeDot = "_38-c";
export var buttonContainer = "_38-9";
export var channelButton = "_38-a";
export var clickable = "_38-d";
export var content = "_38-0";
export var contentFull = "_38-2";
export var contentThird = "_38-1";
export var contentWrapper = "_38-7";
export var description = "_38-5";
export var heightShort = "_38-f";
export var image = "_38-3";
export var imageContainer = "_38-4";
export var selectButton = "_38-e";
export var spinnerContainer = "_38-b";
export var titleContent = "_38-8";
export var titleWrapper = "_38-6";